<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :width="70"
        :submit="handleSubmitFormUpdateRelationNode"
        @close="handleClose">
        <template #body>
            <div class="w-full h-full flex">
                <div class="w-1/2">
                    <hts-card>
                        <template #title>
                            <h3 class="title">
                                <hi-forward-icon class="icon overturned" />
                                <span class="label">
                                    {{ $t('labels.nodeModule.updateRelationNode') }}
                                </span>
                            </h3>
                        </template>
                        <div
                            class="grid gap-5"
                            :class="columnClass">
                            <div class="h-full">
                                <div class="max-w-sm pb-9">
                                    <select-node @change-input="(nodeData:any)=>handleChangeInput(nodeData)" />
                                </div>
                                <div class="grid grid-cols-1 gap-4">
                                    <div
                                        v-for="(item, index) in relationNodeList"
                                        :key="index">
                                        <hts-form-disclosure
                                            color="main"
                                            size="large"
                                            :is-have-children="false"
                                            :is-have-remove-icon="true"
                                            @remove="handleRemoveRelationNode(index)"
                                            @click="handleClickToView(item, index)">
                                            <template #reference>
                                                <div>
                                                    <span class="ml-3 mt-5">
                                                        {{ item.name }} - {{ checkTypeName(item.type) }}
                                                    </span>
                                                </div>
                                            </template>
                                        </hts-form-disclosure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </hts-card>
                </div>
                <div class="w-1/2 h-800">
                    <hts-map-node
                        height="height:580px"
                        :center-position="nodePosition"
                        center-marker />
                </div>
            </div>
        </template>
    </hts-slide-over>
</template>
<script lang="ts" setup>
import SelectNode from './autocomplete/select-node.vue'
import { $urlSystem } from '#imports'

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: Number,
    default: 0
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  nodeIsSelectedToEdit: {
    type: Object,
    default: () => {}
  },
  nodeId: {
    type: String,
    default: ''
  }
})
const { nodeId } = toRefs(props)
const nodePosition = reactive({
  lat: 10.7561542,
  lng: 106.6896784
})
const relationNodeList = ref<Array<{ [key: string]: any }>>([])
const emits = defineEmits(['close', 'refreshTables', 'changeInput'])
watch(props, () => {
  _init()
})
const _init = () => {
  if (!props.nodeIsSelectedToEdit.relationNodeDetail) {
    return null
  }
  relationNodeList.value = [...props.nodeIsSelectedToEdit.relationNodeDetail]
}
const checkTypeName = (type: string) => {
  if (!type) {
    return null
  }
  switch (type) {
  case 'PORT':
    return $t('labels.nodeModule.port')
  case 'DEPOT':
    return $t('labels.nodeModule.depot')
  case 'ICD':
    return $t('labels.nodeModule.icd')
  case 'WAREHOUSE':
    return $t('labels.nodeModule.warehouse')
  case 'HUB':
    return $t('labels.nodeModule.hub')
  case 'TOLL_STATION':
    return $t('labels.nodeModule.tollStation')
  default:
    break
  }
}
const handleRemoveRelationNode = (index: number) => {
  relationNodeList.value.splice(index, 1)
}
const handleClose = () => {
  emits('close')
}
const handleChangeInput = (nodeData: any) => {
  const checkExist = relationNodeList.value.find((item: any) => item.name === nodeData.name)
  if (checkExist) {
    return $toast().error($t('labels.nodeModule.notDuplicate'))
  }
  relationNodeList.value.push(nodeData)
}
const handleSubmitFormUpdateRelationNode = () => {
  const api = $urlSystem.node.updateRelationNode
  if ($lodash.isEqual(relationNodeList.value, props.nodeIsSelectedToEdit.relationNodeDetail)) {
    return $toast().error($t('labels.nodeModule.dataNotChange'))
  }
  const dataRequest = relationNodeList.value.map((item: any) => item._id)
  $api(api, {
    body: {
      id: nodeId.value,
      relationNode: dataRequest
    }
  })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        emits('refreshTables')
        process.client && $toast().success($t('labels.nodeModule.updateRelationNodeSuccess'))
        emits('close')
      }
    })
    .catch((error: any) => error)
}
const handleClickToView = (item: any, index: number) => {
  Object.assign(nodePosition, {
    lat: parseFloat(item.lat),
    lng: parseFloat(item.lng)
  })
}
const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }
  return 'grid-cols-5'
})
</script>
